module.exports = __webpack_public_path__ + "img/state-light.87848dc3.svg";